// Backend API base URL, sourced from REACT_APP_API_BASE_URL in the .env file.
// Applies to both local dev (`npm start`) and production builds (`npm run build`).
// Falls back to localhost if the env var is not set.
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000';

export const availableRoles = [
    'Admin',
    'Contributor',
    'Pipeline_Manager',
    'Model_Training',
    'Model_Export',
    'logs_visibility',
    'Deployment_Manager',
    'Model_Deployment',
    'Batch_Interference',
    'Model_Terminate',
    'Process_Manager',
    'Manage_Running_Pipeline',
    'Pipeline_Cleanup',
];

// Role hierarchy - Admin role includes all other roles
export const roleHierarchy = {
    'Super_Admin': {
        name: 'Super Admin',
        description: 'Full system access - includes all roles',
        includes: availableRoles
    },
    'Admin': {
        name: 'Admin',
        description: 'Administrative access - includes all feature roles below',
        includes: [
            'Contributor',
            'Pipeline_Manager',
            'Model_Training',
            'Model_Export',
            'logs_visibility',
            'Deployment_Manager',
            'Model_Deployment',
            'Batch_Interference',
            'Model_Terminate',
            'Process_Manager',
            'Manage_Running_Pipeline',
            'Pipeline_Cleanup',
        ]
    },
    'Contributor': {
        name: 'Contributor',
        description: 'Basic access to contribute to pipelines and models'
    },
    'Pipeline_Manager': {
        name: 'Pipeline Manager',
        description: 'Create and manage ML pipelines'
    },
    'Model_Training': {
        name: 'Model Training',
        description: 'Train and tune models'
    },
    'Model_Export': {
        name: 'Model Export',
        description: 'Export trained models'
    },
    'logs_visibility': {
        name: 'Logs Visibility',
        description: 'View system and job logs'
    },
    'Deployment_Manager': {
        name: 'Deployment Manager',
        description: 'Manage model deployments'
    },
    'Model_Deployment': {
        name: 'Model Deployment',
        description: 'Deploy models to production'
    },
    'Batch_Interference': {
        name: 'Batch Inference',
        description: 'Run batch inference jobs'
    },
    'Model_Terminate': {
        name: 'Model Terminate',
        description: 'Terminate running models'
    },
    'Process_Manager': {
        name: 'Process Manager',
        description: 'Manage running processes'
    },
    'Manage_Running_Pipeline': {
        name: 'Manage Running Pipeline',
        description: 'Monitor and manage active pipelines'
    },
    'Pipeline_Cleanup': {
        name: 'Pipeline Cleanup',
        description: 'Clean up old pipeline artifacts'
    }
};